import { useEffect, useRef, useState } from "react";

import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import { hideLoader, showLoader } from "../../../../store/actions";
import { getKycTrackDetails } from "../../../../store/actions/newinvestor";
import {
  getAccountType,
  getPersonalDetails,
  getKycDetails,
  getNomineeList,
  getSchemeDetails,
  getFatcaDetails,
  sendRegistrationOtp,
  validatePan,
  validateRegistrationOtp,
  getCkycDetails,
  getCountriesAndState,
  getBankDetails,
} from "../../../../store/actions/newSubscriber";
import { dateToDDMMYYYByDash } from "../../../../utils/common";
import { useNewSubscriberContext } from "../Context/NewSubsciberContext";
import {
  setACKNumber,
  setAccountTypes,
  setBasicDetails,
  setPersonalDetails,
  setEKYCDetails,
  setKycDetails,
  setKycTrackDetails,
  setNomineeDetails,
  setSchemeDetails,
  setFatcaDetails,
  setStatesAndCountries,
  setBankDetails,
  setSkipKyc,
} from "../Context/NewSubscriberAction";
import FormDateInput from "./lib/formik/DateField";
import FormTextInput from "./lib/formik/InputField";
import Otp from "./lib/Otp";
import CheckboxField from "./lib/formik/CheckboxField";
import { Divider } from "@material-ui/core";
import { _getOptions } from "./util/getOptions";
import { SUCCESS_RESPONSE_CODE } from ".";

const validationSchema = Yup.object().shape({
  pan: Yup.string()
    .matches(/^[A-Z]{3}[P][A-Z]{1}[0-9]{4}[A-Z]{1}$/, "Invalid PAN Number")
    .required("PAN Number is required"),
  dob: Yup.date()
    .nullable()
    .typeError("Invalid Date of Birth")
    .max(new Date(), "Invalid Date of Birth")
    .test(
      "is-over-70",
      "Customers beyond 70 years of age cannot invest in NPS.",
      (value) => {
        const currentDate = new Date();
        const selectedDate = new Date(value);
        const age = Math.floor(
          (currentDate - selectedDate) / (364.25 * 24 * 60 * 60 * 1000)
        );
        return age < 70;
      }
    )
    .required("Date of birth is required"),
});

const NewSubscriberRegistration = ({ refId, pan }) => {
  const {
    dob,
    pan: contextPan,
    mobileNumber,
    email,
    mobileCountryCode,
    dispatch: dispatchContext,
  } = useNewSubscriberContext();

  const initialPAN = process.env.REACT_APP_GENERATE_RANDOM_NPS_PAN
    ? `BSSPS${1000 + Math.floor(9000 * Math.random())}R`
    : pan;
  const initialDOB = process.env.REACT_APP_GENERATE_RANDOM_NPS_PAN
    ? new Date("01/04/2003")
    : dob;
  const initialValues = {
    pan: initialPAN,
    dob: initialDOB,
    taxResident: true,
  };
  const history = useHistory();

  const [isOtpValid, setIsOtpValid] = useState(true);
  const [otpDisplay, setOtpDisplay] = useState(false);
  const [reqGuid, setReqGuid] = useState("");
  const ref = useRef(null);

  const dispatch = useDispatch();

  const sendOTP = async () => {
    var otpResponse;
    const params = {
      MobileNo: mobileCountryCode + mobileNumber || "",
      EmailID: email || "",
      PAN: pan,
    };
    otpResponse = await dispatch(sendRegistrationOtp(params));
    setReqGuid(otpResponse?.data?.ReqGUID);
    // const otpParams = {
    //   PageName: "Registration",
    //   MobileNo: mobileCountryCode + mobileNumber,
    //   ReqSendBy: mobileCountryCode + mobileNumber,
    //   EmailId: email,
    //   SourceApp: "mobile",
    //   MACID: "Security Exception",
    // };
    // if (mobileCountryCode === "+91" || mobileCountryCode === "91") {
    //   otpResponse = await dispatch(generateMobileOtp(otpParams));
    //   setReqGuid(otpResponse.data);
    // } else {
    //   otpResponse = await dispatch(generateEmailOtp(otpParams));
    //   setReqGuid(otpResponse.data);
    // }
  };

  useEffect(() => {
    const call = async () => {
      try {
        dispatch(showLoader());
        const response = await dispatch(
          getKycTrackDetails({ pan: contextPan })
        );
        response && dispatchContext(setKycTrackDetails(response));
        dispatchContext(
          setBasicDetails({
            ResidenceType: "1",
            Nationality: "Indian",
          })
        );
      } catch (error) {
        console.error(error);
        alert(error?.message || error);
      } finally {
        dispatch(hideLoader());
      }
    };
    call();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateAndResumeOnboarding = async (pan) => {
    const { data = {} } = await dispatch(validatePan({ PAN: pan }));
    const { pranGenerated = false } = data;
    if (pranGenerated)
      throw new Error("PRAN with same PAN exists in KFintech CRA");

    const { WF_workFlowNumber } = data;

    if (!WF_workFlowNumber) return;
    dispatchContext(setACKNumber(WF_workFlowNumber));

    const response = await dispatch(
      getPersonalDetails({ AckNumber: WF_workFlowNumber })
    );

    const { data: personalDetails = {} } = response;

    const { DOB = "" } = personalDetails;

    if (!DOB) return;

    return WF_workFlowNumber;
  };

  const dispatchCountriesAndStates = async () => {
    try {
      const { data, statusCode: statesListStatusCode } = await dispatch(
        getCountriesAndState()
      );

      if (Number(statesListStatusCode) !== SUCCESS_RESPONSE_CODE) return;

      const { ListCountries, StatesList } = data;
      const statesList = _getOptions(StatesList, "Id");
      const countriesList = _getOptions(ListCountries, "PK_ID");

      setStatesAndCountries({
        countriesList,
        statesList,
      })(dispatchContext);
    } catch (error) {
      alert(error);
    }
  };

  const handleCkycDetails = async (values) => {
    const { pan, dob, taxResident } = values;
    const formattedDate = dateToDDMMYYYByDash(dob);

    const cKycRequestBody = {
      Pan: pan,
      Dob: formattedDate,
      id_type: "PAN",
      req_id: 103,
    };

    const response = await dispatch(getCkycDetails(cKycRequestBody));

    if (Number(response.statusCode) !== SUCCESS_RESPONSE_CODE) return;

    if (response.data.ckyc_remarks !== "OK") return;

    const {
      MOB_NUM,
      EMAIL,
      FULLNAME,
      MOB_CODE,
      FNAME,
      CKYC_NO,
      GENDER,
      DOB,
      PAN,
      PERM_LINE1,
      PERM_DIST,
      PERM_STATE,
      PERM_COUNTRY,
      PERM_PIN,
    } = response?.data?.result?.PERSONAL_DETAILS || {};

    const { IMAGE = [] } = response.data?.result?.IMAGE_DETAILS || {};

    const photograph = IMAGE.find(
      (details) => details.IMAGE_NAME === "Photograph"
    )?.IMAGE_DATA;

    const isValidCkyc = [
      MOB_NUM,
      EMAIL,
      FULLNAME,
      FNAME,
      CKYC_NO,
      GENDER,
      DOB,
      PAN,
      PERM_LINE1,
      PERM_DIST,
      PERM_STATE,
      PERM_COUNTRY,
      PERM_PIN,
      photograph,
    ].every(Boolean);

    if (!isValidCkyc) return;

    dispatchContext(setEKYCDetails(response));

    dispatchContext(
      setBasicDetails({
        ResidenceType: taxResident ? "1" : null,
        Nationality: "Indian",
        mobileNumber: MOB_NUM ?? "",
        mobileCountryCode: MOB_CODE ?? "+91",
        email: EMAIL ?? "",
        name: FULLNAME ?? "",
        cKYC: response?.data?.ckyc_remarks,
      })
    );

    return response;
  };

  const bulkDispatchContext = async (ackNumber) => {
    const promiseList = [
      dispatch(getPersonalDetails({ AckNumber: ackNumber })),
      dispatch(getNomineeList({ AckNumber: ackNumber })),
      dispatch(getSchemeDetails({ AckNumber: ackNumber })),
      dispatch(getKycDetails({ AckNumber: ackNumber })),
      dispatch(getAccountType({ AckNumber: ackNumber })),
      dispatch(getFatcaDetails({ AckNumber: ackNumber })),
      dispatch(getBankDetails({ AckNumber: ackNumber })),
    ];

    const resolvedPromises = await Promise.all(promiseList);

    const [
      personalDetais,
      nomineeDetails,
      schemeDetails,
      kycDetails,
      accountType,
      fatcaDetails,
      bankDetails,
    ] = resolvedPromises;

    dispatchContext(setPersonalDetails(personalDetais));
    dispatchContext(setNomineeDetails(nomineeDetails));
    dispatchContext(setSchemeDetails(schemeDetails));
    dispatchContext(setKycDetails(kycDetails));
    dispatchContext(setAccountTypes(accountType));
    dispatchContext(setFatcaDetails(fatcaDetails));
    dispatchContext(setBankDetails(bankDetails));

    const { statusCode } = kycDetails;
    if (Number(statusCode) !== SUCCESS_RESPONSE_CODE) return;
    const { data } = kycDetails;

    //IdentiferNum = PAN, Aadhaar or CKYC Number
    //IdentiferType = Type of KYC the user is opted for
    //If Both are falsy then we set skip KYC to true

    const { IdentifierNum, IdentifierType } = data;
    if (Boolean(Number(IdentifierType) && IdentifierNum)) return;
    dispatchContext(setSkipKyc(true));
  };

  const handleSubmit = async (values) => {
    try {
      const { pan, dob } = values;

      dispatch(showLoader());

      await dispatchCountriesAndStates();

      dispatchContext(setBasicDetails({ pan, dob, refId }));
      const ckycDetails = await handleCkycDetails(values);
      const ackNumber = await validateAndResumeOnboarding(pan);
      if (ackNumber) {
        await bulkDispatchContext(ackNumber);
        history.push("/nps/AddSubs/fatca-details");
        return;
      }

      if (ckycDetails) {
        setOtpDisplay(true);
        return;
      }

      history.push("/nps/AddSubs/kyc-details");
    } catch (error) {
      alert(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleOtpSubmit = async (otp) => {
    // const { countryCode } = {};
    const params = {
      OTPCode: otp,
      ReqGUID: reqGuid || "",
      // SourceApp: "mobile",
      // Flag: mobileCountryCode === "+91" || "91" ? "R" : "V",
    };
    try {
      dispatch(showLoader());
      const response = await dispatch(validateRegistrationOtp(params));

      if (Number(response.statusCode) === SUCCESS_RESPONSE_CODE) {
        history.push({
          pathname: "/nps/AddSubs/personal-details",
        });
      } else {
        // alert(response.message);
        setIsOtpValid(false);
        return true;
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const skip = () => {
    dispatchContext(setEKYCDetails({}));
    history.push("/nps/AddSubs/kyc-details");
    return;
  };

  return (
    <div style={{ padding: "30px" }}>
      <div
        style={{
          marginTop: "30px",
          fontSize: "22px",
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          gap: "10px",
          cursor: "pointer",
        }}
        onClick={() => {
          history.push("/dashboard");
        }}
      >
        <ArrowBackIosIcon style={{ color: "#007ac8", fontSize: "28px" }} />
        NPS Investor Onboarding
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          marginTop: "20px",
          background: "white",
        }}
        className="new-investor-card"
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/nps.svg`}
          alt=""
          // style={{ width: "auto", height: "70vh", maxWidth: "600px" }}
          className="nps-img"
        />
        <Divider orientation="vertical" flexItem className="nps-divider" />
        {otpDisplay ? (
          <Otp
            sendOTP={sendOTP}
            submit={handleOtpSubmit}
            isOtpValid={isOtpValid}
            back={() => setOtpDisplay(false)}
            skip={skip}
          />
        ) : (
          <div className="nps-form">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              innerRef={ref}
              onSubmit={handleSubmit}
            >
              {() => (
                <Form>
                  <FormTextInput
                    label="Enter PAN"
                    name="pan"
                    placeholder="Enter PAN Number"
                    required
                    onInput={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                    }}
                  />
                  <FormDateInput
                    label="Date Of Birth"
                    name="dob"
                    placeholder="Enter Date of Birth"
                    required
                  />
                  <CheckboxField
                    label="I am tax resident of India"
                    name="taxResident"
                    disabled={true}
                  />
                  <div className="d-flex justify-content-center">
                    <button
                      type="submit"
                      className="new-investor-button new-investor-active"
                    >
                      Verify
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewSubscriberRegistration;

// const handleSubmit = async (values) => {
//   const { pan, dob, taxResident } = values;
//   const formattedDate = dateToDDMMYYYByDash(dob);

//   const params = {
//     Pan: pan,
//     Dob: formattedDate,
//     id_type: "PAN",
//     req_id: 103,
//   };

//   try {
//     dispatch(showLoader());
//     dispatchContext(setBasicDetails({ pan, dob, refId }));
//     const { data, statusCode: statesListStatusCode } = await dispatch(
//       getCountriesAndState()
//     );

//     if (Number(statesListStatusCode) === 10000) {
//       const { ListCountries, StatesList } = data;
//       const statesList = _getOptions(StatesList, "Id");
//       const countriesList = _getOptions(ListCountries, "PK_ID");
//       setStatesAndCountries({
//         countriesList,
//         statesList,
//       })(dispatchContext);
//     }

//     const AckNumber = await validateAndResumeOnboarding(pan);
//     if (AckNumber) {
//       const [
//         _PersonalDetails,
//         _NomineeDetails,
//         _SchemeDetails,
//         _FundDetails,
//         _KycDetails,
//         _AccountTypes,
//         _FatcaDetails,
//       ] = await Promise.all([
//         dispatch(getPersonalDetails({ AckNumber })),
//         dispatch(getNomineeList({ AckNumber })),
//         dispatch(getSchemeDetails({ AckNumber })),
//         dispatch(getFundChoices()),
//         dispatch(getKycDetails({ AckNumber })),
//         dispatch(getAccountType({ AckNumber })),
//         dispatch(getFatcaDetails({ AckNumber })),
//       ]);

//       dispatchContext(setPersonalDetails(_PersonalDetails));
//       dispatchContext(setNomineeDetails(_NomineeDetails));
//       dispatchContext(setSchemeDetails(_SchemeDetails));
//       dispatchContext(setFundDetails(_FundDetails));
//       dispatchContext(setKycDetails(_KycDetails));
//       dispatchContext(setAccountTypes(_AccountTypes));
//       dispatchContext(setFatcaDetails(_FatcaDetails));

//       history.push("/nps/AddSubs/fatca-details");
//       return;
//     }

//     const response = await dispatch(getCkycDetails(params));
//     if (
//       +response.statusCode === 10000 &&
//       response?.data?.ckyc_remarks === "OK"
//     ) {
//       const {
//         MOB_NUM,
//         EMAIL,
//         FULLNAME,
//         MOB_CODE,
//         FNAME,
//         CKYC_NO,
//         GENDER,
//         DOB,
//         PAN,
//         PERM_LINE1,
//         PERM_DIST,
//         PERM_STATE,
//         PERM_COUNTRY,
//         PERM_PIN,
//       } = response?.data?.result?.PERSONAL_DETAILS || {};

//       const { IMAGE = [] } = response?.data?.result?.IMAGE_DETAILS || {};

//       const photograph = IMAGE.find(
//         (details) => details.IMAGE_NAME === "Photograph"
//       )?.IMAGE_DATA;

//       const isValidCkyc = [
//         MOB_NUM,
//         EMAIL,
//         FULLNAME,
//         FNAME,
//         CKYC_NO,
//         GENDER,
//         DOB,
//         PAN,
//         PERM_LINE1,
//         PERM_DIST,
//         PERM_STATE,
//         PERM_COUNTRY,
//         PERM_PIN,
//         photograph,
//       ].every(Boolean);
//       dispatchContext(setEKYCDetails(response));
//       if (!isValidCkyc) {
//         history.push({
//           pathname: "/nps/AddSubs/kyc-details",
//         });
//         return;
//       }

//       dispatchContext(
//         setBasicDetails({
//           ResidenceType: taxResident ? "1" : null,
//           Nationality: "Indian",
//           mobileNumber: MOB_NUM ?? "",
//           mobileCountryCode: MOB_CODE ?? "+91",
//           email: EMAIL ?? "",
//           name: FULLNAME ?? "",
//           cKYC: response?.data?.ckyc_remarks,
//         })
//       );

//       if (taxResident !== true) {
//         history.push({
//           pathname: "/nps/AddSubs/kyc-details",
//         });
//         return;
//       }
//       setOtpDisplay(true);
//     } else {
//       history.push({
//         pathname: "/nps/AddSubs/kyc-details",
//       });
//     }
//   } catch (error) {
//     console.error(error);
//     alert(error);
//     if (error?.message === "PRAN with same PAN exists in KFintech CRA") {
//       return;
//     }
//     history.push({
//       pathname: "/nps/AddSubs/kyc-details",
//     });
//   } finally {
//     dispatch(hideLoader());
//   }
// };
